import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: '💳',
      title: 'Rechargez votre compte',
      description: 'Rechargez facilement votre compte avec Orange Money, Sama Money, Stripe ou un code de recharge.',
      screenshot: '/screenshots/topup-1.PNG',
    },
    {
      icon: '💳',
      title: 'Gérez vos cartes',
      description: 'Visualisez et gérez toutes vos cartes en un seul endroit. Consultez l\'historique des transactions par carte.',
      screenshot: '/screenshots/cards-1.PNG',
    },
    {
      icon: '📋',
      title: 'Historique des transactions',
      description: 'Consultez l\'historique complet de toutes vos transactions avec des détails précis.',
      screenshot: '/screenshots/transaction-1.PNG',
    },
    {
      icon: '🔒',
      title: 'Sécurité renforcée',
      description: 'Authentification biométrique pour protéger votre compte et vos transactions.',
      screenshot: '/screenshots/login-1.PNG',
    },
    {
      icon: '⚡',
      title: 'Rapide et simple',
      description: 'Interface intuitive et réactive pour une expérience utilisateur optimale.',
      screenshot: '/screenshots/home-1.PNG',
    },
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <h2 className="section-title">Fonctionnalités</h2>
        <p className="section-subtitle">
          Découvrez toutes les fonctionnalités de Shini Pay
        </p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-image-container">
                <img 
                  src={feature.screenshot} 
                  alt={feature.title}
                  className="feature-image"
                />
              </div>
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;

